import LandingImg from './assets/landing_img-removebg.png'

export const HeroData = {
    title: 'Share Your Space Without',
    subtitle: 'Find a college roommate that fits your lifestyle',
    btnText: 'Match Now!',
    img: LandingImg,
}